import React, { useState } from "react";
import { criarSimulacaoPublica } from "../services/api";

// 🌐 "TESTAR AGORA, SEM CRIAR CONTA" (23/10/2026, Nelson: no piloto a simulação vale para todos, sem conta).
// Nada é enviado ao colega antes de quem entrevista confirmar o próprio e-mail (link de 24 h) — ver SimulacaoEndpoints.
const campo = "mt-1 w-full rounded-lg border border-gray-300 px-3 py-2";

export default function SimulacaoPublicaForm() {
  const [f, setF] = useState({ nomeRecrutador: "", emailRecrutador: "", empresa: "", nomeColega: "", emailColega: "", agora: true, data: "", aceite: false });
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const muda = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const email = (v) => /\S+@\S+\.\S+/.test(v.trim());
  const mesmos = f.emailRecrutador.trim() && f.emailRecrutador.trim().toLowerCase() === f.emailColega.trim().toLowerCase();
  const pronto = f.nomeRecrutador.trim().length >= 2 && email(f.emailRecrutador) && f.nomeColega.trim().length >= 2 && email(f.emailColega)
    && !mesmos && (f.agora || f.data) && f.aceite;
  const minimo = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  const enviar = async () => {
    setErro(""); setEnviando(true);
    try {
      const r = await criarSimulacaoPublica({
        nomeRecrutador: f.nomeRecrutador.trim(), emailRecrutador: f.emailRecrutador.trim(), empresa: f.empresa.trim() || null,
        nomeColega: f.nomeColega.trim(), emailColega: f.emailColega.trim(), agora: f.agora,
        inicio: f.agora ? null : new Date(f.data).toISOString(), aceite: f.aceite,
      });
      setOk(r);
    } catch (e) { setErro(e.message); } finally { setEnviando(false); }
  };
  if (ok) {
    return (
      <section className="rounded-2xl border border-green-200 bg-green-50 p-5 mt-6 text-green-900">
        <p className="font-bold text-lg">📬 Confira o seu e-mail</p>
        <p className="mt-1 text-sm">{ok.reenviado ? "Reenviamos" : "Mandamos"} um link de confirmação para <b>{ok.email}</b>. Assim que você confirmar,
          o convite vai para o seu colega e você recebe o seu link da sala. O link vale por 24 horas (confira também o spam).</p>
      </section>
    );
  }
  return (
    <section id="testar" className="bg-white rounded-2xl shadow-sm p-5 mt-6 text-sm">
      <h2 className="font-bold text-text text-lg">🧪 Testar agora, sem criar conta</h2>
      <p className="text-gray-600 mt-1">Durante o piloto, qualquer pessoa pode testar. A conversa dura até 15 minutos.</p>
      <div className="grid md:grid-cols-2 gap-3 mt-4">
        <label className="block"><span className="text-gray-600">Seu nome (quem vai entrevistar)</span>
          <input value={f.nomeRecrutador} onChange={muda("nomeRecrutador")} maxLength={80} className={campo} /></label>
        <label className="block"><span className="text-gray-600">Seu e-mail</span>
          <input type="email" value={f.emailRecrutador} onChange={muda("emailRecrutador")} maxLength={200} className={campo} /></label>
        <label className="block md:col-span-2"><span className="text-gray-600">Empresa (opcional)</span>
          <input value={f.empresa} onChange={muda("empresa")} maxLength={120} className={campo} /></label>
        <label className="block"><span className="text-gray-600">Nome do colega (faz o papel de candidato)</span>
          <input value={f.nomeColega} onChange={muda("nomeColega")} maxLength={80} className={campo} /></label>
        <label className="block"><span className="text-gray-600">E-mail do colega</span>
          <input type="email" value={f.emailColega} onChange={muda("emailColega")} maxLength={200} className={campo} /></label>
      </div>
      {mesmos && <p className="mt-2 text-xs text-red-700">O seu e-mail e o do colega precisam ser diferentes: cada um recebe o próprio link.</p>}
      <div className="mt-3">
        <span className="text-gray-600">Quando</span>
        <div className="flex flex-wrap gap-4 mt-1">
          <label className="flex items-center gap-1.5"><input type="radio" checked={f.agora} onChange={() => setF((x) => ({ ...x, agora: true }))} /> Agora (assim que eu confirmar o e-mail)</label>
          <label className="flex items-center gap-1.5"><input type="radio" checked={!f.agora} onChange={() => setF((x) => ({ ...x, agora: false }))} /> Escolher data e hora</label>
        </div>
        {!f.agora && <input type="datetime-local" min={minimo} value={f.data} onChange={muda("data")} className={campo} />}
      </div>
      <label className="flex items-start gap-2 mt-4 text-gray-700">
        <input type="checkbox" className="mt-1" checked={f.aceite} onChange={muda("aceite")} />
        <span>Por ser um piloto, a equipe do eaiRH pode ler o feedback desta simulação para melhorar a ferramenta.</span>
      </label>
      <p className="text-xs text-gray-500 mt-2">
        Privacidade: usamos os nomes e e-mails só para mandar os convites, os lembretes, o feedback de cada um e um formulário
        rápido no fim. O colega só recebe algo depois que você confirmar o seu e-mail. A transcrição da conversa é apagada
        depois de gerar o feedback. Veja a <a href="/privacidade" className="text-primary underline">política de privacidade</a>.
      </p>
      {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 px-3 py-2">{erro}</p>}
      <div className="flex justify-end mt-4">
        <button onClick={enviar} disabled={!pronto || enviando}
          className="rounded-lg bg-accent hover:opacity-90 disabled:opacity-40 text-white font-semibold px-5 py-2.5">{enviando ? "Enviando…" : "Quero testar agora"}</button>
      </div>
    </section>
  );
}
